import { createFileRoute } from "@tanstack/react-router";
import { EpisodePage } from "@/features/game-resources";
import { loadEpisode } from "@/features/game-resources/records";
import {
  resourceHead,
  resourceSearchSchema,
} from "@/features/game-resources/navigation";

export const Route = createFileRoute(
  "/_site/unlisted/$coworld_/episodes/$episodeId",
)({
  validateSearch: (search) => resourceSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ params, deps, abortController }) =>
    loadEpisode({
      data: {
        resourceId: params.episodeId,
        game: { slug: params.coworld, catalog_status: "unlisted" },
        search: deps.search,
      },
      signal: abortController.signal,
    }),
  head: () => resourceHead("Episode"),
  component: Page,
});

function Page() {
  return <EpisodePage data={Route.useLoaderData()} />;
}
